function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.8328483,10.8332993 L8.97416719,10.8332993 L12.8257677,6.99812679 C13.2834337,6.54102764 13.2834337,5.7999235 12.8257677,5.34282436 C12.3681016,4.88572521 11.6260784,4.88572521 11.1684123,5.34282436 L5.332654,11.171354 C5.22639577,11.282217 5.14310202,11.4129451 5.08755215,11.556037 C4.97081595,11.8398413 4.97081595,12.1581692 5.08755215,12.4419735 C5.14310202,12.5850654 5.22639577,12.7157935 5.332654,12.8266565 L11.1684123,18.6551861 C11.3875644,18.875869 11.6858836,19 11.99709,19 C12.3082965,19 12.6066156,18.875869 12.8257677,18.6551861 C13.0467243,18.4363055 13.1710092,18.1383559 13.1710092,17.8275349 C13.1710092,17.516714 13.0467243,17.2187643 12.8257677,16.9998837 L8.97416719,13.1647112 L17.8328483,13.1647112 C18.4774484,13.1647112 19,12.6428069 19,11.9990052 C19,11.3552036 18.4774484,10.8332993 17.8328483,10.8332993 Z",
  id: "path-left"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Arrow-/-Left",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2-left",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-left"
})), /*#__PURE__*/React.createElement("use", {
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#path-left"
}), /*#__PURE__*/React.createElement("g", {
  id: "Color-/-Black",
  mask: "url(#mask-2-left)",
  fill: "#333333"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})));

var SvgLeft = function SvgLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left.a4b41db7.svg";
export { ForwardRef as ReactComponent };